import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { authApi } from '../api/auth'
import AuthShell from '../components/AuthShell'
import { inputCls, labelCls, primaryBtn } from '../components/form'

export default function SetupAccount() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password !== confirm) { setError('비밀번호가 일치하지 않습니다.'); return }
    setLoading(true)
    try {
      await authApi.setupAccount(token, password, name)
      navigate('/login')
    } catch {
      setError('계정 설정에 실패했습니다. 초대 링크를 확인하세요.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell title="계정 설정" lead="초대받은 계정에 쓸 이름과 비밀번호를 정하세요.">
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="sa-name" className={labelCls}>이름</label>
          <input id="sa-name" autoComplete="name" value={name} onChange={e => setName(e.target.value)} required autoFocus className={inputCls} />
        </div>
        <div>
          <label htmlFor="sa-pw" className={labelCls}>비밀번호</label>
          <input id="sa-pw" type="password" autoComplete="new-password" value={password} onChange={e => setPassword(e.target.value)} required className={inputCls} />
        </div>
        <div>
          <label htmlFor="sa-confirm" className={labelCls}>비밀번호 확인</label>
          <input id="sa-confirm" type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} required className={inputCls} />
        </div>
        {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
        <button type="submit" disabled={loading} className={`w-full ${primaryBtn} py-2.5`}>
          {loading ? '설정하는 중…' : '계정 활성화'}
        </button>
      </form>
    </AuthShell>
  )
}
